import { render, staticRenderFns } from "./PostingList.vue?vue&type=template&id=49307b4c&scoped=true"
import script from "./PostingList.vue?vue&type=script&lang=js"
export * from "./PostingList.vue?vue&type=script&lang=js"
import style0 from "./PostingList.vue?vue&type=style&index=0&id=49307b4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49307b4c",
  null
  
)

export default component.exports